import React from 'react';
import { useInstallationContext } from '../../../context/installation';
import { IntegrationType } from '../../../data-access/gql-types/graphql';
import { useNative } from '../../../hooks/native/use-native';
import { AboutSettings, LanguageSettings, ThemeSettings, VibrationSettings } from './sections';
import { ReadingChatSettings } from './sections/reading-chat';

const ApplicationSettings: React.FC = () => {
  const { integrationType } = useInstallationContext();
  const { vibrationSupported } = useNative();

  return (
    <>
      <div className="grid-list-24">
        <LanguageSettings />
        <ThemeSettings />
        {vibrationSupported && <VibrationSettings />}
        {integrationType === IntegrationType.Exalus && <ReadingChatSettings />}
      </div>
      <AboutSettings />
    </>
  );
};

export default ApplicationSettings;
